// extracted by mini-css-extract-plugin
module.exports = {"costContainer":"Cost_costContainer__GaT8F","costDescription":"Cost_costDescription__zKrXh","cost":"Cost_cost__3H4X-"};